module.exports = __webpack_public_path__ + "static/media/PersoRouge.2f0df290.png";